export default "__VITE_ASSET__2efc915a__"